<template>
  <confirm-user />
</template>

<script>
import ConfirmUser from '@/components/login/ConfirmUser.vue';

export default {
  components: {
    ConfirmUser,
  },
  mounted() {},
};
</script>
